import { create } from 'zustand';
import { devtools, DevtoolsOptions, persist } from 'zustand/middleware';
import type { ThoughtSpotSlice } from './slices/createThoughtspotSlice';
import { createThoughtSpotSlice } from './slices/createThoughtspotSlice';
import type { AppSlice } from './slices/createAppSlice';
import { createAppSlice } from './slices/createAppSlice';
import { isProductionOrPreProduction } from '@/lib/env';

const devtoolsOptions: DevtoolsOptions = {
  enabled: !isProductionOrPreProduction(),
};

export const useThoughtSpotStore = create<ThoughtSpotSlice>()(
  devtools(createThoughtSpotSlice, {
    ...devtoolsOptions,
    name: 'thoughtspot',
  }),
);

type DashboardStore = ThoughtSpotSlice & AppSlice;

export const useBoundStore = create<DashboardStore>()(
  devtools(
    persist(
      (...args) => ({
        ...createAppSlice(...args),
        ...createThoughtSpotSlice(...args),
      }),
      {
        name: 'dashboard-store',
        version: 1,
        partialize: (state) => ({
          selectedRegion: state.selectedRegion,
          impersonatedUser: state.impersonatedUser,
        }),
        onRehydrateStorage: () => (state) => {
          if (state) {
            state.setHasHydrated(true);
          }
        },
      },
    ),
    { ...devtoolsOptions, name: 'bound-store' },
  ),
);
